import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { debounce } from 'lodash';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import List from '@shared/component/List';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CheckValidator from '@shared/checkValidator';
import { ActionValues, actionsPermissionValidator } from '@utils/static/commonUtils';
import Lists from '@shared/component/Lists';
export function Penalty() {
    const { setLoader } = useContext(AuthContext);
    const [Penalty, setPenalty] = useState([]);
    const [id, setId] = useState(null);

    const [isSubmit, setIsSubmit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [formData, setFormData] = useState<any>({
        penaltyType: null,
        durationOfDelay: null,
        penaltyAmount: null,
    });
    const listRef: any = useRef(null);
    const [showHideModel, setShowHideModel] = useState(false);
    const [edit, setEdit] = useState(false);
    const [errors, setError] = useState<any>({
        penaltyType: {
            required: true,
            error: true,
            message: 'Please enter penalty type',
            pattern: /^[A-Za-z0-9\s]*$/,
            maxLength: 30,
        },
        durationOfDelay: {
            required: true,
            error: true,
            message: 'Please enter duration',
            pattern: /^[A-Za-z0-9\s]*$/,
            maxLength: 15,
        },
        penaltyAmount: {
            required: true,
            error: true,
            message: 'Please enter amount',
            pattern: /^\d+$/,
            maxLength: 6,
        },
    });

    const [columns, setColumns] = useState({
        id: 'ID',
        penaltyType: 'Penalty Type',
        durationOfDelay: 'Duration Of Delay',
        penaltyAmount: 'Penalty Amount',
        status: 'Status',
        action: 'Action',
    });

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
        } catch (error) {}
    };
    const searchItem = async (value: any, page: any = 1) => {
        try {
            const data = await APIService.getAll(
                `penalty/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setPenalty(data.data.data);
            setRecordCount(data?.data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    const getPenalty = async (page: any = 1) => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`penalty/?page=${page}&sort=createdAt`, true, false);
            setPenalty(data.data.data);
            setRecordCount(data?.data?.count || 0);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };
    const getValue = (e: any) => {
        try {
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) {}
    };

    useEffect(() => {
        getPenalty();
    }, []);

    const addPenalty = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);
            if (isValid) {
                const isduration = parseDuration(formData?.durationOfDelay);
                const data = {
                    penaltyType: formData?.penaltyType,
                    durationOfDelay: formData?.durationOfDelay,
                    isDurationInMinute: isduration.toString(),
                    penaltyAmount: formData?.penaltyAmount,
                };
                setLoader(true);
                const updateddata = await APIService.post('penalty', data, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    Notify('success', 'Penalty type created successfully');
                    setEdit(false);
                    handelModel(false);
                    setFormData({
                        ['penaltyType']: null,
                        ['durationOfDelay']: null,
                        ['isDurationInMinute']: null,
                        ['penaltyAmount']: null,
                        ['status']: null,
                    });
                    getPenalty();
                    listRef.current.clearSearchBox();
                } else {
                    Notify('error', updateddata.data.message);
                }
            }
        } catch (err) {
            setLoader(false);

            Notify('error', err.response.data.message);
        }
    };
    function parseDuration(duration: any) {
        const minRegex = /(\d+)\s*min/;
        const hourRegex = /(\d+)\s*hour/;
        const hourMinRegex = /(\d+)\s*hour\s*(\d+)\s*min/;
        const daysRegex = /(\d+)\s*days/;
        //console.log(hourRegex.test(duration))
        if (hourMinRegex.test(duration)) {
            const [, hours, minutes] = duration.match(hourMinRegex);

            return parseInt(hours) * 60 + parseInt(minutes);
        } else if (hourRegex.test(duration)) {
            const [, hours] = duration.match(hourRegex);

            return parseInt(hours) * 60;
        } else if (minRegex.test(duration)) {
            const [, minutes] = duration.match(minRegex);

            return parseInt(minutes);
        } else if (daysRegex.test(duration)) {
            const [, days] = duration.match(daysRegex);
            return parseInt(days) * 24 * 60;
        }

        return 0; // Invalid format
    }
    const updateStatus = async (item: any, status: any, id: any, page: any) => {
        try {
            const data = {
                penaltyType: item.penaltyType,
                durationOfDelay: item.durationOfDelay,
                isDurationInMinute: item.durationOfDelay,
                penaltyAmount: item.penaltyAmount,
                status: status,
            };
            setLoader(true);
            const updateddata = await APIService.update('penalty', id, data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Penalty type status updated');
                getPenalty(page);
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const updatePenalty = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);
            if (isValid) {
                const isduration = parseDuration(formData?.durationOfDelay);
                const data = {
                    penaltyType: formData?.penaltyType,
                    durationOfDelay: formData?.durationOfDelay,
                    isDurationInMinute: isduration.toString(),
                    penaltyAmount: formData?.penaltyAmount,
                    status: formData?.status,
                };
                setLoader(true);
                const updateddata = await APIService.update('penalty', id, data, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    Notify('success', 'Penalty type updated successfully');
                    setEdit(false);
                    handelModel(false);
                    setFormData({
                        ['penaltyType']: null,
                        ['durationOfDelay']: null,
                        ['isDurationInMinute']: null,
                        ['penaltyAmount']: null,
                        ['status']: null,
                    });
                    getPenalty();
                    listRef.current.clearSearchBox(true);
                } else {
                    Notify('error', updateddata.data.message);
                }
            }
        } catch (err) {
            setLoader(false);

            Notify('error', err.response.data.message);
        }
    };
    const getPenaltyById = async (id: any) => {
        try {
            setLoader(true);
            const updateddata = await APIService.getById('penalty', id, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                setFormData({
                    ['penaltyType']: updateddata.data.getAllData[0].penaltyType,
                    ['durationOfDelay']: updateddata.data.getAllData[0].durationOfDelay,
                    ['penaltyAmount']: updateddata.data.getAllData[0].penaltyAmount,
                    ['status']: updateddata.data.getAllData[0].status,
                });
                setEdit(true);
                handelModel(true);
                setId(updateddata.data.getAllData[0].id);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getDeleteIds = async (ids: any) => {
        try {
            const data = {
                ids: JSON.stringify(ids),
            };
            setLoader(true);
            const updateddata = await APIService.post('penalty/delete', data, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Penalty type delete successfully');
                setLoader(false);
                getPenalty();
            }
        } catch (err) {
            setLoader(false);
            Notify('error', err.response.data.message);
            getPenalty();
        }
    };

    const handlereset = () => {
        setEdit(false);
        setFormData({
            ['penaltyType']: null,
            ['durationOfDelay']: null,
            ['isDurationInMinute']: null,
            ['penaltyAmount']: null,
            ['status']: null,
        });
        handelModel(false);
    };
    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Penalty Type</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    {/* <List
                        headTitles={['Penalty Type', 'Duration Of Delay', 'Penalty Amount']}
                        searchItem={searchItem}
                        tab={'type...'}
                        list={Penalty}
                        updateStatus={updateStatus}
                        getById={getPenaltyById}
                        getDeleteIds={getDeleteIds}
                        addUpdateText="Penalty Type"
                        handelModel={(e: boolean) => handelModel(e)}
                        recordCount={recordCount}
                        callPagination={getPenalty}
                    /> */}

                    <></>
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={Penalty}
                        searchItem={searchItem}
                        type={'add+delete'}
                        getById={getPenaltyById}
                        updateStatus={updateStatus}
                        getDeleteIds={getDeleteIds}
                        addUpdateText="Penalty Type"
                        handelModel={(e: boolean) => handelModel(e)}
                        recordCount={recordCount}
                        callPagination={getPenalty}
                        // showFilter={true}
                    />
                </div>

                {showHideModel && (
                    <Modal show={true} onHide={() => handlereset()} backdrop="static" size="lg" keyboard={false}>
                        <Modal.Header closeButton>
                            <Modal.Title> {edit ? 'Edit Penalty Type' : 'Add Penalty Type'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="field_box field_no_margin">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Penalty Type',
                                                            name: 'penaltyType',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="penaltyType"
                                                        isSubmit={isSubmit}
                                                        value={formData?.penaltyType}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.penaltyType.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-4">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Duration Of Delay',
                                                            name: 'durationOfDelay',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="durationOfDelay"
                                                        isSubmit={isSubmit}
                                                        value={formData?.durationOfDelay}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.durationOfDelay.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Penalty Amount',
                                                            name: 'durationOfDelay',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="penaltyAmount"
                                                        isSubmit={isSubmit}
                                                        value={formData?.penaltyAmount}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.penaltyAmount.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                onClick={edit ? updatePenalty : addPenalty}
                            >
                                {edit ? 'Update' : 'Add'}
                            </Button>
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    handlereset();
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}
